<template>
    <div>
        <div v-if="basketEmptied" class="alert alert-info alert-dismissible fade show" role="alert">
			<strong>Tyres removed! - </strong> It isn't possible to add both fully fitted and delivered tyres to your order. Any tyres you had previously selected have been removed from your basket.
			<button type="button" class="btn-close" @click="basketEmptied = false" data-bs-dismiss="alert" aria-label="Close"></button>
		</div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                basketEmptied: false
            }
        },
        mounted() {
            this.emitter.on('basketEmptied', data => {
                this.basketEmptied = true;
            });
        }
    }
</script>

<style lang="scss" scoped>

</style>